import { env as runtimeEnv } from 'next-runtime-env';

const env = (key: string) => runtimeEnv(key) as string;

export const SETTINGS = {
  public: {
    tmsToken: env('NEXT_PUBLIC_TMS_TOKEN'),
    urlTermSvc: env('NEXT_PUBLIC_URL_TERM_SVC'),
    basePath: env('NEXT_PUBLIC_BASE_PATH'),
  },
  server: {
    basePath: env('BASE_PATH'),
  },
};
